export default __webpack_public_path__ + "locales/pl/PeopleTranslations.json?hash=19cfa92fa8231011948acfc828ecdc0b";